module.exports = __webpack_public_path__ + "img/5-3.db9f4dd4.svg";